<template>
    <!--滚动固定时 +fixation-->
    <!-- :class="{'fixation':fixationDir}" -->
    <div class="m-slide-left"
        
         id="leftTabMenu">
        <div class="ml-slide-inner">

            <ul>
                <li style="margin-left: 25px;font-weight: 600;font-size:16px;">
                    我想看
                </li>
                <li :class="{'active':item.id == currentTagId}"
                    v-for="(item,index) in lists"
                    :key="index" >
                    <!-- <router-link
            :to="{name:'caseIndex',params:{id:item.id}}"
            tag="a"
            class="ml-slide-tit"
          >{{item.tagName}}</router-link>-->
                    <i class="ml-line-icon"></i>
                    <a @click="filterTag(item.id,item.tagName)"
                       class="ml-slide-tit">{{item.tagName}}<i style="color:#808080;position: relative;left: 20px;" class="kine">/</i></a>
                    
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
   
    name: 'left-menu',
    props: ['lists', 'currentTagId', 'fixationDir'],
    data() {
        return {
            // currentTagId: undefined
        };
    },
    methods: {
        filterTag(id,tagName) {
            // this.currentTagId = id;
            this.$emit('filterTag', id,tagName);
        },
    
        
    },
    created() {

    }
};
</script>

<style scoped>
    .m-slide-left{
        width: 100%;
        padding: 0px 0px;     
        border-radius: 4px;
    }
    .m-slide-left li{
        display: inline-block;
        padding: 17px 12px 12px 12px;
    }
    .m-slide-left li:last-child .kine{display:none}
    .m-slide-left{
        background-color: rgba(255,255,255,1);
    }
    .m-slide-left li .ml-slide-tit{
        margin: 0 4px;
        color: #999999;
        font-size:14px;
        overflow: inherit;
    }
    .m-slide-left li>a{
          width: 100%;
          padding:0px 5px;
    }
    .m-slide-left li.active>a{
    color: #00b86d;
    font-size:14px;
    font-weight: 600;
    
    }
    .m-slide-left li>a:hover{
        color:#999999;border-color:transparent;
        background: #fff;
        }
    .m-slide-left li.active:hover .ml-slide-tit{background: #fff;}
     .m-slide-left li>a:visited{
       border: hidden;
     }
     .ml-slide-inner{
         box-shadow: 0px 3px 21px 0px rgba(77, 77, 77, 0.15);
     }   
    .ml-slide-inner>ul{
        border-bottom: 1px rgba(244,244,244,1) solid;
        width: 1170px;
    }
    .m-slide-left.fixation{
        top:110px;
    }
    .m-slide-left{margin-top:-50px;}
    .m-slide-left .ml-line-icon{background:inherit}
    
</style>
